"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPubkeys = exports.makeMarketMetadataAndBracket = exports.fetchPredictionMarkets = exports.marketFetcher = exports.bracketFetcher = exports.selectMarket = exports.parseOpenOrders = exports.getTokenCountsFromResponse = exports.makeGMAReq = exports.getL2 = exports.filterOpenOrders = exports.genInitTradeTx = exports.genInitTradeIx = exports.generateSellNoAccObj = exports.generateBuyNoAccObj = exports.generateTradeYesAccObj = void 0;
const token_instructions_1 = require("@project-serum/serum/lib/token-instructions");
const axios_1 = __importDefault(require("axios"));
const consts_1 = require("./consts");
const serum_1 = require("@project-serum/serum");
const lodash_1 = __importStar(require("lodash"));
const loadMarkets_1 = require("./utils/loadMarkets");
const misc_1 = require("./utils/misc");
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const instructions_1 = require("./generated/instructions");
function generateInitTradeYesAccObj(user, pubkeys) {
    const { bracket, lockedYesFUsdc, unlockedYes, dexProgram, fUsdcMint, yesMint, tradeYesAccount, openOrdersYes, serumMarket, internalUsdc, marketPnl, } = pubkeys;
    return {
        user,
        internalUsdc,
        bracket,
        tradeYes: tradeYesAccount,
        serumMarket,
        openOrders: openOrdersYes,
        yesMint,
        fUsdcMint,
        unlockedYes,
        lockedFUsdc: lockedYesFUsdc,
        dexProgram,
        marketPnl,
        tokenProgram: token_instructions_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
        systemProgram: web3_js_1.SystemProgram.programId,
    };
}
function generateTradeYesAccObj(user, pubkeys) {
    const { bracket, lockedYesFUsdc, unlockedYes, userUsdc, dexProgram, fUsdcMint, usdcVault, tradeYesAccount, market, openOrdersYes, serumMarket, serumAccounts, marketPnl, } = pubkeys;
    return {
        bracket,
        serumAccounts,
        serumMarket,
        usdcVault,
        market,
        fUsdcMint,
        tradeYes: tradeYesAccount,
        openOrders: openOrdersYes,
        unlockedYes,
        lockedFUsdc: lockedYesFUsdc,
        user,
        userUsdc,
        marketPnl,
        dexProgram,
        tokenProgram: token_instructions_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    };
}
exports.generateTradeYesAccObj = generateTradeYesAccObj;
function generateInitBuyNoAccObj(user, pubkeys) {
    const { bracket, dexProgram, fUsdcMint, yesMint, noMint, serumMarket, internalUsdc, unlockedNo, tradeNoAccount, openOrdersBuyNo, lockedBuyNoFUsdc, lockedBuyNoYes, marketPnl, } = pubkeys;
    return {
        user,
        bracket,
        tradeNo: tradeNoAccount,
        marketPnl,
        serumMarket,
        yesMint,
        noMint,
        fUsdcMint,
        internalUsdc,
        openOrders: openOrdersBuyNo,
        lockedYes: lockedBuyNoYes,
        lockedFUsdc: lockedBuyNoFUsdc,
        unlockedNo,
        dexProgram,
        tokenProgram: token_instructions_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
        systemProgram: web3_js_1.SystemProgram.programId,
    };
}
function generateBuyNoAccObj(user, pubkeys) {
    const { bracket, userUsdc, dexProgram, fUsdcMint, usdcVault, yesMint, noMint, market, serumMarket, unlockedNo, serumAccounts, tradeNoAccount, openOrdersBuyNo, lockedBuyNoFUsdc, lockedBuyNoYes, marketPnl, } = pubkeys;
    return {
        user,
        market,
        userUsdc,
        bracket,
        serumMarket,
        serumAccounts,
        usdcVault,
        yesMint,
        noMint,
        fUsdcMint,
        tradeNo: tradeNoAccount,
        marketPnl,
        openOrders: openOrdersBuyNo,
        lockedYes: lockedBuyNoYes,
        lockedFUsdc: lockedBuyNoFUsdc,
        unlockedNo,
        dexProgram,
        tokenProgram: token_instructions_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    };
}
exports.generateBuyNoAccObj = generateBuyNoAccObj;
function generateInitSellNoAccObj(user, pubkeys) {
    const { bracket, dexProgram, fUsdcMint, yesMint, noMint, serumMarket, tradeNoAccount, openOrdersSellNo, lockedSellNoFUsdc, lockedSellNoYes, lockedSellNoNo, } = pubkeys;
    return {
        user,
        bracket,
        serumMarket,
        yesMint,
        noMint,
        fUsdcMint,
        tradeNo: tradeNoAccount,
        openOrders: openOrdersSellNo,
        lockedYes: lockedSellNoYes,
        lockedNo: lockedSellNoNo,
        lockedFUsdc: lockedSellNoFUsdc,
        dexProgram,
        tokenProgram: token_instructions_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
        systemProgram: web3_js_1.SystemProgram.programId,
    };
}
function generateSellNoAccObj(user, pubkeys) {
    const { bracket, userUsdc, dexProgram, fUsdcMint, usdcVault, yesMint, noMint, market, serumMarket, unlockedNo, serumAccounts, tradeNoAccount, openOrdersSellNo, lockedSellNoFUsdc, lockedSellNoYes, lockedSellNoNo, marketPnl, } = pubkeys;
    return {
        user,
        userUsdc,
        bracket,
        market,
        marketPnl,
        serumAccounts,
        serumMarket,
        usdcVault,
        yesMint,
        noMint,
        fUsdcMint,
        tradeNo: tradeNoAccount,
        openOrders: openOrdersSellNo,
        lockedYes: lockedSellNoYes,
        lockedNo: lockedSellNoNo,
        lockedFUsdc: lockedSellNoFUsdc,
        unlockedNo,
        dexProgram,
        tokenProgram: token_instructions_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    };
}
exports.generateSellNoAccObj = generateSellNoAccObj;
function genInitTradeIx(type, pubkeys, user) {
    if (type === consts_1.MARKET_TYPE.BUY_YES || type === consts_1.MARKET_TYPE.SELL_YES) {
        const bumps = pubkeys.tradeYesBumps;
        const initAccountObj = generateInitTradeYesAccObj(user, pubkeys);
        return (0, instructions_1.initTradesYes)({ bumps }, initAccountObj);
    }
    else if (type === consts_1.MARKET_TYPE.BUY_NO) {
        const bumps = pubkeys.buyNoBumps;
        const initAccountObj = generateInitBuyNoAccObj(user, pubkeys);
        return (0, instructions_1.initBuyNo)({ bumps }, initAccountObj);
    }
    else if (type === consts_1.MARKET_TYPE.SELL_NO) {
        const bumps = pubkeys.sellNoBumps;
        const initAccountObj = generateInitSellNoAccObj(user, pubkeys);
        return (0, instructions_1.initSellNo)({ bumps }, initAccountObj);
    }
    else {
        throw new Error(`Unrecognized market type ${type}`);
    }
}
exports.genInitTradeIx = genInitTradeIx;
function genInitTradeTx(marketPnl, internalTokenAuth, type, pubkeys, user, usdcMint) {
    const preInstructions = [];
    if (!marketPnl) {
        if (!internalTokenAuth) {
            preInstructions.push((0, instructions_1.initInternalUsdc)({
                internalTokenAuthBump: pubkeys.miscBumps.internalTokenAuthBump,
                internalUsdcBump: pubkeys.miscBumps.internalUsdcBump,
            }, {
                user,
                internalTokenAuth: pubkeys.internalTokenAuth,
                internalUsdc: pubkeys.internalUsdc,
                tokenProgram: token_instructions_1.TOKEN_PROGRAM_ID,
                rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                usdcMint,
                systemProgram: web3_js_1.SystemProgram.programId,
            }));
        }
        preInstructions.push((0, instructions_1.initMarketPnl)({ bump: pubkeys.miscBumps.marketPnlBump }, {
            user,
            market: pubkeys.market,
            marketPnl: pubkeys.marketPnl,
            systemProgram: web3_js_1.SystemProgram.programId,
        }));
    }
    const initIx = genInitTradeIx(type, pubkeys, user);
    return new web3_js_1.Transaction().add(...preInstructions, initIx);
}
exports.genInitTradeTx = genInitTradeTx;
const findProgramAddressSync = anchor_1.utils.publicKey.findProgramAddressSync;
function filterOpenOrders(bids, asks, openOrdersAccounts) {
    return [...bids, ...asks].filter((order) => openOrdersAccounts.some((openOrders) => order.openOrdersAddress?.equals(openOrders?.address)));
}
exports.filterOpenOrders = filterOpenOrders;
function getPriceFromKey(key) {
    return key.ushrn(64);
}
function getL2({ depth, descending = null, item, }) {
    const { slab } = item;
    const levels = [];
    if (slab.items) {
        for (const { key, quantity } of slab.items(descending || item.isBids)) {
            const price = getPriceFromKey(key);
            function e(x, n) {
                let base = new anchor_1.BN(10).pow(new anchor_1.BN(n));
                let dm = new anchor_1.BN(x)["divmod"](base);
                return dm.div + "." + dm.mod.toString(10, n);
            }
            const updatePrice = Number(e(price, 3));
            levels.push([updatePrice, quantity]);
            if (levels.length === depth) {
                break;
            }
        }
        const getObjOfPrices = {};
        levels.forEach((i) => {
            if (getObjOfPrices[i[0]]) {
                const newSum = getObjOfPrices[i[0]] + Number(i[1]);
                getObjOfPrices[i[0]] = newSum;
            }
            else {
                getObjOfPrices[i[0]] = Number(i[1]);
            }
        });
        const uniqArray = (0, lodash_1.sortedUniqBy)(levels, 0);
        return uniqArray.map(([priceLots]) => [
            priceLots,
            new anchor_1.BN(getObjOfPrices[priceLots]).div(new anchor_1.BN(100)).toNumber(),
        ]);
    }
    return [];
}
exports.getL2 = getL2;
function makeGMAReq(pubkeys, commitment) {
    // used to handle the extremely rare edge case where we dont have a valid bracket account but we do have a market list.
    // should never happen irl.
    const pubkeyStrings = pubkeys.map((i) => i ? i.toString() : "foresightfakeZ1TMrokrefnpMqzmLZMecLGhvnWbbb");
    const commitmentToUse = commitment || "confirmed";
    return {
        jsonrpc: "2.0",
        id: 1,
        method: "getMultipleAccounts",
        params: [
            pubkeyStrings,
            {
                commitment: commitmentToUse,
            },
        ],
    };
}
exports.makeGMAReq = makeGMAReq;
function makeGetTokenAccountBalanceRequest(token, commitment) {
    return {
        jsonrpc: "2.0",
        id: 1,
        method: "getTokenAccountBalance",
        params: [token.toBase58(), { commitment: commitment }],
    };
}
function makeGetParsedAccountInfoRequest(pubkey, commitment) {
    return {
        jsonrpc: "2.0",
        id: 1,
        method: "getAccountInfo",
        params: [
            pubkey.toBase58(),
            {
                encoding: "jsonParsed",
                commitment: commitment,
            },
        ],
    };
}
function bracketDetailsToOwnedTokensReqs(bracketDetails, user, commitment) {
    let idBytes = Uint8Array.from(bracketDetails.bracket.id);
    let marketIdBytes = Uint8Array.from(bracketDetails.bracket.marketId);
    let marketListIdBytes = Uint8Array.from(bracketDetails.bracket.marketListId);
    let [unlockedYes] = findProgramAddressSync([
        user.toBuffer(),
        Buffer.from("unlocked_yes"),
        Buffer.from(consts_1.BUFFERED_ORDERS.TRADE_YES),
        idBytes,
        marketIdBytes,
        marketListIdBytes,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let [unlockedNo] = findProgramAddressSync([
        user.toBuffer(),
        Buffer.from(consts_1.PREDICTION_MARKET_BUFFERS.UNLOCKED_NO),
        Buffer.from(consts_1.BUFFERED_ORDERS.TRADE_NO),
        idBytes,
        marketIdBytes,
        marketListIdBytes,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let [noMint] = findProgramAddressSync([Buffer.from("no_mint"), idBytes, marketIdBytes, marketListIdBytes], consts_1.PROGRAM_ID_PUBKEY);
    return [
        makeGetTokenAccountBalanceRequest(unlockedYes, commitment),
        makeGetTokenAccountBalanceRequest(unlockedNo, commitment),
        makeGetParsedAccountInfoRequest(noMint, commitment),
    ];
}
function makeOwnedTokensReqs({ user, brackets, commitment, }) {
    function mapper(bracketDetails) {
        return bracketDetailsToOwnedTokensReqs(bracketDetails, user, commitment);
    }
    const nestedReqs = brackets.map(mapper);
    return nestedReqs;
}
const getTokenCountsFromResponse = (yesTokens, noTokens) => {
    let unlockedYesTokens = {};
    let unlockedNoTokens = {};
    if (yesTokens?.result?.value) {
        unlockedYesTokens = yesTokens.result.value;
    }
    if (noTokens?.result?.value) {
        unlockedNoTokens = noTokens.result.value;
    }
    return { unlockedYesTokens, unlockedNoTokens };
};
exports.getTokenCountsFromResponse = getTokenCountsFromResponse;
// TODO dynamically change dexId.
function parseOpenOrders({ dexId, fetchedData, buyYes, buyNo, sellNo, }) {
    let tradeYesOpenOrders = null;
    let buyNoOpenOrders = null;
    let sellNoOpenOrders = null;
    fetchedData.forEach((acc_info, i) => {
        const item = acc_info;
        if (i === 0 && item?.data) {
            const myBuffer = Buffer.from(item?.data[0], item?.data[1]);
            const decoded = serum_1.OpenOrders.getLayout(dexId).decode(myBuffer);
            tradeYesOpenOrders = new serum_1.OpenOrders(buyYes, decoded, dexId);
        }
        if (i === 1 && item?.data) {
            const myBuffer = Buffer.from(item?.data[0], item?.data[1]);
            const decoded = serum_1.OpenOrders.getLayout(dexId).decode(myBuffer);
            buyNoOpenOrders = new serum_1.OpenOrders(buyNo, decoded, dexId);
        }
        if (i === 2 && item?.data) {
            const myBuffer = Buffer.from(item?.data[0], item?.data[1]);
            const decoded = serum_1.OpenOrders.getLayout(dexId).decode(myBuffer);
            sellNoOpenOrders = new serum_1.OpenOrders(sellNo, decoded, dexId);
        }
    });
    return {
        tradeYesOpenOrders,
        buyNoOpenOrders,
        sellNoOpenOrders,
    };
}
exports.parseOpenOrders = parseOpenOrders;
async function selectMarket({ market, provider, customCallback = ({ type, action }) => { }, dexId, signal, }) {
    const { openOrdersYes, unlockedNo, unlockedYes, openOrdersBuyNo, openOrdersSellNo, noMint, } = market.pubkeys;
    const commitmentToUse = provider.opts.commitment || "confirmed";
    try {
        const tokenBalance = await axios_1.default.post(provider.connection.rpcEndpoint, [
            makeGetTokenAccountBalanceRequest(unlockedYes, commitmentToUse),
            makeGetTokenAccountBalanceRequest(unlockedNo, commitmentToUse),
            makeGMAReq([openOrdersYes, openOrdersBuyNo, openOrdersSellNo], commitmentToUse),
            {
                jsonrpc: "2.0",
                id: 1,
                method: "getAccountInfo",
                params: [
                    noMint.toBase58(),
                    {
                        encoding: "jsonParsed",
                        commitment: commitmentToUse,
                    },
                ],
            },
        ], {
            signal,
        });
        const [unlockedYesResponse, unlockedNoResponse, fetchedData, openInterestMintDetails,] = tokenBalance.data;
        const { unlockedYesTokens, unlockedNoTokens } = (0, exports.getTokenCountsFromResponse)(unlockedYesResponse, unlockedNoResponse);
        try {
            const openOrders = parseOpenOrders({
                dexId,
                fetchedData: fetchedData?.result?.value,
                buyYes: openOrdersYes,
                buyNo: openOrdersBuyNo,
                sellNo: openOrdersSellNo,
            });
            let tradeYesOrders = [];
            let buyNoOrders = [];
            let sellNoOrders = [];
            if (openOrders.tradeYesOpenOrders) {
                tradeYesOrders = filterOpenOrders(market.orderbookDetail.bids, market.orderbookDetail.asks, [openOrders.tradeYesOpenOrders]);
            }
            if (openOrders.buyNoOpenOrders) {
                buyNoOrders = filterOpenOrders(market.orderbookDetail.bids, market.orderbookDetail.asks, [openOrders.buyNoOpenOrders]);
            }
            if (openOrders.sellNoOpenOrders) {
                sellNoOrders = filterOpenOrders(market.orderbookDetail.bids, market.orderbookDetail.asks, [openOrders.sellNoOpenOrders]);
            }
            customCallback({
                type: consts_1.CALLBACK_TYPES.SUCCESS,
                action: {
                    market: {
                        market,
                        openOrders: {
                            tradeYesOrders,
                            buyNoOrders,
                            sellNoOrders,
                        },
                        openInterest: openInterestMintDetails?.result?.value?.data.parsed.info.supply,
                        unlockedYesTokens,
                        unlockedNoTokens,
                    },
                },
            });
            return {
                market,
                openOrders: {
                    tradeYesOrders,
                    buyNoOrders,
                    sellNoOrders,
                },
                openInterest: openInterestMintDetails?.result?.value?.data.parsed.info.supply,
                unlockedYesTokens,
                unlockedNoTokens,
            };
        }
        catch (e) {
            customCallback({
                type: consts_1.CALLBACK_TYPES.FAIL,
                action: {
                    market: {
                        market,
                        openOrders: {},
                        unlockedYesTokens,
                        unlockedNoTokens,
                        openInterest: openInterestMintDetails?.result?.value?.data.parsed.info.supply,
                    },
                },
            });
        }
        return {
            market,
            openOrders: {},
            unlockedYesTokens,
            unlockedNoTokens,
            openInterest: openInterestMintDetails?.result?.value?.data.parsed.info.supply,
        };
    }
    catch (e) {
        // console.error(e);
        customCallback({
            type: consts_1.CALLBACK_TYPES.FAIL,
            action: {
                market: {
                    market,
                    openOrders: {},
                    unlockedYesTokens: {},
                    unlockedNoTokens: {},
                    openInterest: null,
                },
            },
        });
        return {
            market,
            openOrders: {},
            unlockedYesTokens: {},
            unlockedNoTokens: {},
            openInterest: null,
        };
    }
}
exports.selectMarket = selectMarket;
function bracketFetcher(marketList) {
    const bracketSeeds = marketList.markets.map((marketDetails) => {
        if (marketList.numMarkets > 0) {
            let getBrackets = [];
            for (let bracketNum = 0; bracketNum < marketDetails.numBrackets; bracketNum++) {
                getBrackets.push(bracketNum);
            }
            const brackets = getBrackets.map((bracketNum) => {
                let [bracket] = findProgramAddressSync([
                    Buffer.from("bracket"),
                    Uint8Array.from([bracketNum]),
                    Uint8Array.from(marketDetails.id),
                    Uint8Array.from(marketList.marketListId),
                ], consts_1.PROGRAM_ID_PUBKEY);
                return {
                    bracket,
                    marketListId: marketList.marketListId,
                    marketDetailsId: marketDetails.id,
                };
            });
            return brackets;
        }
        else
            return;
    });
    return (0, lodash_1.flatten)(bracketSeeds);
}
exports.bracketFetcher = bracketFetcher;
async function marketFetcher(marketList) {
    const fetchedMarketSeeds = marketList.markets.map((marketDetails, i) => {
        if (marketList.numMarkets > i) {
            let [market, marketBump] = findProgramAddressSync([
                Buffer.from("market"),
                Uint8Array.from(marketDetails.id),
                Uint8Array.from(marketList.marketListId),
            ], consts_1.PROGRAM_ID_PUBKEY);
            let [marketMetadata, marketMetadataBump] = findProgramAddressSync([
                Buffer.from("market_metadata"),
                Uint8Array.from(marketDetails.id),
                Uint8Array.from(marketList.marketListId),
            ], consts_1.PROGRAM_ID_PUBKEY);
            return {
                market,
                marketBump,
                marketMetadata,
                marketMetadataBump,
            };
        }
        else
            return;
    });
    return fetchedMarketSeeds;
}
exports.marketFetcher = marketFetcher;
async function fetchPredictionMarkets({ marketList, provider, DEX_PID, userUsdc, }) {
    const items = [];
    for (const bracketDetails of marketList) {
        let [bracketAccount] = findProgramAddressSync([
            Buffer.from("serum_market"),
            Uint8Array.from(bracketDetails.bracket.id),
            Uint8Array.from(bracketDetails.bracket.marketId),
            Uint8Array.from(bracketDetails.bracket.marketListId),
        ], consts_1.PROGRAM_ID_PUBKEY);
        items.push(bracketAccount);
    }
    const parsedMarkets = items.map((i) => i.toString());
    const nestedReqs = makeOwnedTokensReqs({
        user: provider.wallet.publicKey,
        brackets: marketList,
        commitment: provider.opts.commitment,
    });
    const fetchMarketsAndTokenBalances = await axios_1.default.post(provider.connection.rpcEndpoint, [
        makeGMAReq(items, provider.opts.commitment),
        ...nestedReqs.flat(),
    ]);
    const gmaResp = fetchMarketsAndTokenBalances.data[0];
    const responseTrioResps = fetchMarketsAndTokenBalances.data.slice(1);
    const unlockedYesBalances = responseTrioResps.filter((x, index) => index % 3 === 0);
    const unlockedNoBalances = responseTrioResps.filter((x, index) => index % 3 === 1);
    const mintInfos = responseTrioResps.filter((x, index) => index % 3 === 2);
    const loadedMarkets = await (0, loadMarkets_1.loadMarkets)(gmaResp, {}, parsedMarkets, DEX_PID);
    const bids = [];
    const asks = [];
    loadedMarkets?.forEach((items) => {
        if (items.bidsAddress) {
            bids.push(items.bidsAddress.toBase58());
            asks.push(items.asksAddress.toBase58());
        }
        else {
            bids.push("");
            asks.push("");
        }
    });
    const orderbookDetails = await (0, misc_1.loadOrderbook)(bids, asks, loadedMarkets, provider.connection.rpcEndpoint, provider.opts.commitment);
    const zipped = lodash_1.default.zip(unlockedYesBalances, unlockedNoBalances, mintInfos);
    const finalArray = zipped.map((trio) => {
        const { unlockedYesTokens, unlockedNoTokens } = (0, exports.getTokenCountsFromResponse)(trio[0], trio[1]);
        return {
            unlockedNoTokens,
            unlockedYesTokens,
            openInterestSupply: trio[2].result.value.data.parsed
                .info.supply,
        };
    });
    const allPubkeys = (0, exports.fetchPubkeys)(marketList, loadedMarkets, provider.wallet.publicKey, DEX_PID, userUsdc);
    const newData = loadedMarkets.map((item, i) => {
        if (item) {
            // TODO: remove the spread metadata from details in the Front end and just use market.metadata isntead to prevent bugs
            item.details = {
                ...marketList[i].metadata,
                market: marketList[i].market,
                bracket: marketList[i].bracket,
            };
            item.metadata = marketList[i].metadata;
            item.bracket = marketList[i].bracket;
            item.marketListIdString = marketList[i].bracket.marketListId.toString();
            item.pubkeys = {
                ...allPubkeys[i],
            };
            item.mintDetails = fetchMarketsAndTokenBalances.data[i].result?.value?.data?.parsed?.info;
            const asksDepth = orderbookDetails.asks[i]
                ? (0, lodash_1.cloneDeep)(getL2({
                    item: orderbookDetails.asks[i],
                    depth: 333,
                    descending: null,
                }))
                : null;
            const bidsDepth = orderbookDetails.bids[i]
                ? (0, lodash_1.cloneDeep)(getL2({
                    item: orderbookDetails.bids[i],
                    depth: 333,
                    descending: null,
                }))
                : null;
            item.orderbookDetail = {
                asks: orderbookDetails.asks[i],
                asksDepth,
                bids: orderbookDetails.bids[i],
                bidsDepth,
            };
            item.ownedTokens = {
                noTokens: finalArray?.[i]?.unlockedNoTokens,
                yesTokens: finalArray?.[i]?.unlockedYesTokens,
            };
            item.openInterest = finalArray?.[i]?.openInterestSupply;
            item.marketIndex = i;
            return item;
        }
        return {};
    });
    return newData;
}
exports.fetchPredictionMarkets = fetchPredictionMarkets;
function makeMarketMetadataAndBracket(metadata, category, market, bracket) {
    const rules = Buffer.from(metadata?.rules)?.toString();
    const description = Buffer.from(metadata?.description)?.toString();
    const marketName = Buffer.from(metadata?.marketName)?.toString();
    const image = Buffer.from(metadata?.image)?.toString();
    return {
        market: market,
        metadata: {
            ...metadata,
            rules,
            description,
            marketName,
            image,
            category,
            marketEnd: metadata.marketEnd ? metadata.marketEnd.toNumber() : null,
        },
        marketListIdString: bracket.marketListId.toString(),
        bracket: bracket,
    };
}
exports.makeMarketMetadataAndBracket = makeMarketMetadataAndBracket;
const fetchPubkeys = (markets, loadedMarkets, user, DEX_PID, userUsdc) => {
    let [internalUsdc, internalUsdcBump] = findProgramAddressSync([user.toBuffer(), Buffer.from("internal_usdc")], consts_1.PROGRAM_ID_PUBKEY);
    let [internalTokenAuth, internalTokenAuthBump] = findProgramAddressSync([user.toBuffer(), Buffer.from("internal_token_auth")], consts_1.PROGRAM_ID_PUBKEY);
    const joinedMarketsTuples = lodash_1.default.zip(markets, loadedMarkets);
    const returnKeys = joinedMarketsTuples.map((joinedMarkets) => {
        const [marketDetails, loadedMarket] = joinedMarkets;
        const bracketObj = marketDetails.bracket;
        const bracketId = Uint8Array.from(bracketObj.id);
        const marketId = Uint8Array.from(bracketObj.marketId);
        const marketListId = Buffer.from(bracketObj.marketListId);
        let [market] = findProgramAddressSync([Buffer.from("market"), marketId, marketListId], consts_1.PROGRAM_ID_PUBKEY);
        let [bracket] = findProgramAddressSync([Buffer.from("bracket"), bracketId, marketId, marketListId], consts_1.PROGRAM_ID_PUBKEY);
        let [openOrdersYes, openOrdersYesBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.PREDICTION_MARKET_BUFFERS.OPEN_ORDERS),
            Buffer.from(consts_1.BUFFERED_ORDERS.TRADE_YES),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [tradeYesAccount, tradeAccountYesBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.BUFFERED_ORDERS.TRADE_YES),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [unlockedYes, unlockedYesBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.PREDICTION_MARKET_BUFFERS.UNLOCKED_YES),
            Buffer.from(consts_1.BUFFERED_ORDERS.TRADE_YES),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [lockedYesFUsdc, lockedYesFUsdcBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.PREDICTION_MARKET_BUFFERS.LOCKED_FUSDC),
            Buffer.from(consts_1.BUFFERED_ORDERS.TRADE_YES),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [tradeNoAccount, tradeNoAccountBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.BUFFERED_ORDERS.TRADE_NO),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [openOrdersBuyNo, openOrderBuyNoBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.PREDICTION_MARKET_BUFFERS.OPEN_ORDERS),
            Buffer.from(consts_1.BUFFERED_ORDERS.BUY_NO),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [openOrdersSellNo, openOrderSellNoBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.PREDICTION_MARKET_BUFFERS.OPEN_ORDERS),
            Buffer.from(consts_1.BUFFERED_ORDERS.SELL_NO),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [lockedBuyNoNo, lockedBuyNoNoBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.PREDICTION_MARKET_BUFFERS.LOCKED_NO),
            Buffer.from(consts_1.BUFFERED_ORDERS.BUY_NO),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [lockedSellNoNo, lockedSellNoNoBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.PREDICTION_MARKET_BUFFERS.LOCKED_NO),
            Buffer.from(consts_1.BUFFERED_ORDERS.SELL_NO),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [unlockedNo, unlockedNoBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.PREDICTION_MARKET_BUFFERS.UNLOCKED_NO),
            Buffer.from(consts_1.BUFFERED_ORDERS.TRADE_NO),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [lockedBuyNoYes, lockedBuyNoYesBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.PREDICTION_MARKET_BUFFERS.LOCKED_YES),
            Buffer.from(consts_1.BUFFERED_ORDERS.BUY_NO),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [lockedSellNoYes, lockedSellNoYesBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.PREDICTION_MARKET_BUFFERS.LOCKED_YES),
            Buffer.from(consts_1.BUFFERED_ORDERS.SELL_NO),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [lockedBuyNoFUsdc, lockedBuyNoFUsdcBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.PREDICTION_MARKET_BUFFERS.LOCKED_FUSDC),
            Buffer.from(consts_1.BUFFERED_ORDERS.BUY_NO),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [lockedSellNoFUsdc, lockedSellNoFUsdcBump] = findProgramAddressSync([
            user.toBuffer(),
            Buffer.from(consts_1.PREDICTION_MARKET_BUFFERS.LOCKED_FUSDC),
            Buffer.from(consts_1.BUFFERED_ORDERS.SELL_NO),
            bracketId,
            marketId,
            marketListId,
        ], consts_1.PROGRAM_ID_PUBKEY);
        let [usdcVault, usdcVaultBump] = findProgramAddressSync([Buffer.from("usdc_vault"), bracketId, marketId, marketListId], consts_1.PROGRAM_ID_PUBKEY);
        let [yesMint, yesMintBump] = findProgramAddressSync([Buffer.from("yes_mint"), bracketId, marketId, marketListId], consts_1.PROGRAM_ID_PUBKEY);
        let [noMint, noMintBump] = findProgramAddressSync([Buffer.from("no_mint"), bracketId, marketId, marketListId], consts_1.PROGRAM_ID_PUBKEY);
        let [fUsdcMint, fUsdcMintBump] = findProgramAddressSync([Buffer.from("f_usdc_mint"), bracketId, marketId, marketListId], consts_1.PROGRAM_ID_PUBKEY);
        let [marketPnl, marketPnlBump] = findProgramAddressSync([user.toBuffer(), Buffer.from("market_pnl"), marketId, marketListId], consts_1.PROGRAM_ID_PUBKEY);
        let [vaultSigner, vaultSignerBump] = (0, misc_1.getVaultOwnerAndNonce)(loadedMarket.address, DEX_PID);
        const miscBumps = {
            fUsdcMintBump,
            noMintBump,
            yesMintBump,
            usdcVaultBump,
            vaultSignerBump,
            internalUsdcBump,
            marketPnlBump,
            internalTokenAuthBump,
        };
        const tradeYesBumps = {
            marketPnl: marketPnlBump,
            tradeYes: tradeAccountYesBump,
            openOrders: openOrdersYesBump,
            unlockedYes: unlockedYesBump,
            lockedFUsdc: lockedYesFUsdcBump,
            internalUsdc: internalUsdcBump,
        };
        const buyNoBumps = {
            marketPnl: marketPnlBump,
            tradeNo: tradeNoAccountBump,
            openOrders: openOrderBuyNoBump,
            lockedYes: lockedBuyNoYesBump,
            lockedNo: lockedBuyNoNoBump,
            unlockedNo: unlockedNoBump,
            lockedFUsdc: lockedBuyNoFUsdcBump,
            internalUsdc: internalUsdcBump,
        };
        const sellNoBumps = {
            marketPnl: marketPnlBump,
            tradeNo: tradeNoAccountBump,
            openOrders: openOrderSellNoBump,
            lockedYes: lockedSellNoYesBump,
            lockedNo: lockedSellNoNoBump,
            unlockedNo: unlockedNoBump,
            lockedFUsdc: lockedSellNoFUsdcBump,
            internalUsdc: internalUsdcBump,
        };
        const pubkeys = {
            serumMarket: loadedMarket.address,
            serumAccounts: {
                vaultSigner,
                requestQueue: loadedMarket.decoded.requestQueue,
                eventQueue: loadedMarket.decoded.eventQueue,
                bids: loadedMarket.bidsAddress,
                asks: loadedMarket.asksAddress,
                coinVault: loadedMarket.decoded.baseVault,
                pcVault: loadedMarket.decoded.quoteVault,
            },
            marketPnl,
            internalTokenAuth,
            internalUsdc,
            lockedBuyNoFUsdc,
            lockedSellNoFUsdc,
            unlockedNo,
            lockedBuyNoNo,
            lockedBuyNoYes,
            lockedSellNoYes,
            lockedSellNoNo,
            openOrdersBuyNo,
            openOrdersSellNo,
            tradeNoAccount,
            lockedYesFUsdc,
            openOrdersYes,
            tradeYesAccount,
            unlockedYes,
            usdcVault,
            yesMint,
            noMint,
            vaultSigner,
            fUsdcMint,
            bracket,
            market,
            dexProgram: DEX_PID,
            userUsdc: userUsdc?.publicKey || userUsdc,
            tokenProgram: token_instructions_1.TOKEN_PROGRAM_ID,
            rent: web3_js_1.SYSVAR_RENT_PUBKEY,
        };
        Object.keys(pubkeys).forEach((i) => {
            if (pubkeys[i]?.toString()) {
                // console.log(pubkeys[i].toString(), i);
            }
        });
        return {
            ...pubkeys,
            buyNoBumps,
            sellNoBumps,
            tradeYesBumps,
            miscBumps,
        };
    });
    return returnKeys;
};
exports.fetchPubkeys = fetchPubkeys;
//# sourceMappingURL=helpers.js.map